import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function notAllowedCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    //regex expression that matches only ASCII characters
    const regex = /[^\x20-\x7E]/;
    const isValid = regex.test(control.value);
    return isValid ? { notAllowedCharacters: { value: control.value } } : null;
  };
}
